<template>
  <JoinWrapper>
    <!-- PROGRESS BAR -->
    <JoinProgress :stage="stage" />
    <!-- / PROGRESS BAR -->

    <div class="topic">약관동의</div>
    <p class="guide_ment">
      회원구분을 선택하신 후 서비스 이용약관 및<br />개인정보 수집이용에
      동의해주세요.
    </p>
    <div class="box">
      <ul class="member_type">
        <li class="student_wrap">
          <input
            id="student"
            v-model="memberTp"
            type="radio"
            value="1000"
            name="memberType"
          />
          <label for="student">
            학생(일반회원)
          </label>
        </li>
        <li class="teacher_wrap">
          <input
            id="teacher"
            v-model="memberTp"
            type="radio"
            value="2000"
            name="memberType"
          />
          <label for="teacher">
            교·강사 회원
          </label>
        </li>
      </ul>
      <ul class="join_check">
        <li class="check_all">
          <div class="text_label">
            <label>
              <input
                v-model="checkedAll"
                type="checkbox"
                name="agree"
                class="check_agree"
                @click="toggleCheckAll"
              />
              <em></em>
              <span>약관 전체동의</span>
            </label>
          </div>
        </li>
        <li>
          <div class="text_label">
            <label>
              <input
                v-model="agreedTerms"
                value="termsOfUse"
                type="checkbox"
                name="agree"
                class="check_agree"
                @change="handleTermChange"
              />
              <em></em>
              <span>
                <span class="terms_text terms_necessary">[필수]</span>
                <span class="word_space">이용약관</span>
              </span>
            </label>
          </div>
          <button class="box_btn line" @click="navigateToTerms">
            <span class="an_t">
              <img src="@/assets/images/login_join/arrow.png" alt="더보기" />
            </span>
          </button>
        </li>
        <li>
          <div class="text_label">
            <label>
              <input
                v-model="agreedTerms"
                value="collectAndUse"
                type="checkbox"
                name="agree"
                class="check_agree"
                @change="handleTermChange"
              />
              <em></em>
              <span>
                <span class="terms_text terms_necessary">[필수]</span>
                <span class="word_space">개인정보 수집 및 이용 동의</span>
              </span>
            </label>
          </div>
          <button class="box_btn line" @click="navigateToPrivacy">
            <span class="an_t">
              <img src="@/assets/images/login_join/arrow.png" alt="더보기" />
            </span>
          </button>
        </li>
        <!-- 마케팅 활용 동의 및 광고 수신 동의 -->
        <li>
          <div class="text_label">
            <label class="border_division">
              <input
                v-model="contactMethods.emailSms.selected"
                value="emailSms"
                type="checkbox"
                name="agree"
                class="check_agree"
                @change="handleEmailSmsChange"
              />
              <em></em>
              <span>
                <span class="terms_text terms_choice">[선택]</span>
                <span class="word_space">
                  마케팅 활용 동의 및 광고 수신 동의
                </span>
              </span>
            </label>
          </div>
        </li>
        <li>
          <div class="text_label pdl">
            <label class="email_box">
              <input
                v-model="contactMethods.email.selected"
                value="email"
                type="checkbox"
                name="agree"
                class="check_agree"
                @change="handleEmailOrMessagesChange"
              />
              <em class="none_circle"></em>
              <span>
                <span class="bottom_font">이메일 수신동의</span>
              </span>
            </label>
          </div>
        </li>
        <li>
          <div class="text_label pdl">
            <label class="smsmms_box">
              <input
                v-model="contactMethods.messages.selected"
                value="messages"
                type="checkbox"
                name="agree"
                class="check_agree"
                @change="handleEmailOrMessagesChange"
              />
              <em class="none_circle"></em>
              <span>
                <span class="bottom_font">SMS/MMS 수신동의</span>
              </span>
            </label>
          </div>
        </li>
      </ul>
      <p class="benefit_info">
        서비스와 관련된 신상품 소식, 이벤트 안내, 고객 혜택 등 다양한 정보를
        제공합니다.
      </p>
      <div class="btn_wrap">
        <button
          :disabled="!isValid"
          class="box_btn next_btn"
          :class="{ dull: !isValid }"
          @click="nextStep"
        >
          다음
        </button>
      </div>
    </div>
  </JoinWrapper>
</template>

<script>
import JoinWrapper from '@/components/auth/JoinWrapper.vue'
import JoinProgress from '@/components/auth/JoinProgress.vue'
import { MEMBER_TYPE_NORMAL, MEMBER_TYPE_TEACHER } from '@/store/types'
export default {
  name: 'JoinStep1',
  components: {
    JoinProgress,
    JoinWrapper
  },
  data() {
    return {
      stage: 1,
      agreedTerms: [],
      contactMethods: {
        emailSms: { selected: false, value: 'emailSms' },
        email: { selected: false, value: 'email' },
        messages: { selected: false, value: 'messages' }
      },
      checkedAll: false,
      memberTp: null,
      id: this.$route.query.id,
      type: this.$route.query.type
    }
  },
  computed: {
    isValid() {
      const requiredTerms = ['termsOfUse', 'collectAndUse']
      const hasAllRequiredTerms = requiredTerms.every((term) =>
        this.agreedTerms.includes(term)
      )
      return hasAllRequiredTerms && this.memberTp !== null
    },
    hasAllContactMethods() {
      return (
        this.contactMethods.email.selected &&
        this.contactMethods.messages.selected
      )
    },
    selectedContactMethods() {
      return Object.values(this.contactMethods)
        .filter((method) => method.selected)
        .map((method) => method.value)
    }
  },
  methods: {
    toggleCheckAll() {
      this.checkedAll = !this.checkedAll
      if (this.checkedAll) {
        this.agreedTerms = ['termsOfUse', 'collectAndUse']
        this.contactMethods.emailSms.selected = true
        this.contactMethods.email.selected = true
        this.contactMethods.messages.selected = true
      } else {
        this.agreedTerms = []
        this.contactMethods.emailSms.selected = false
        this.contactMethods.email.selected = false
        this.contactMethods.messages.selected = false
      }
    },
    handleTermChange() {
      this.updateCheckedAll()
    },
    handleEmailSmsChange() {
      this.contactMethods.email.selected = this.contactMethods.emailSms.selected
      this.contactMethods.messages.selected = this.contactMethods.emailSms.selected
      this.updateCheckedAll()
    },
    handleEmailOrMessagesChange() {
      this.contactMethods.emailSms.selected =
        this.contactMethods.email.selected &&
        this.contactMethods.messages.selected
      this.updateCheckedAll()
    },
    updateCheckedAll() {
      this.checkedAll =
        this.agreedTerms.includes('termsOfUse') &&
        this.agreedTerms.includes('collectAndUse') &&
        this.contactMethods.emailSms.selected
    },
    formatRegisterData() {
      return { memberTp: this.memberTp }
    },
    nextStep() {
      if (!this.isValid) return
      const terms = this.createBooleanStateObject(
        ['termsOfUse', 'collectAndUse'],
        this.agreedTerms
      )
      const data = this.formatRegisterData()
      this.commitMemberType(data)
      this.$store.dispatch('setCookie', {
        name: 'ealice_mail1',
        value: terms,
        exp: 30
      })
      /**
       * sns, 이메일 분기 처리
       * NEW_USER(sns에서 진입) -> step4
       * 이메일 가입 -> step2
       */
      if (this.type === 'NEW_USER') {
        this.$router.push({
          name: 'join_step4',
          query: { id: this.id, type: this.type },
          params: { data, terms, contactMethods: this.contactMethods }
        })
      } else {
        this.$router.push({
          name: 'join_step2',
          params: { data, terms, contactMethods: this.contactMethods }
        })
      }
    },
    commitMemberType(data) {
      try {
        if (this.memberTp === '1000') {
          this.$store.commit(MEMBER_TYPE_NORMAL, { data })
        } else {
          this.$store.commit(MEMBER_TYPE_TEACHER, { data })
        }
      } catch (err) {
        this.toggleErrorModal()
      }
    },
    createBooleanStateObject(keys, selectedItems) {
      const result = {}
      keys.forEach((key) => {
        result[key] = selectedItems.includes(key)
      })
      return result
    },
    openInNewTab(routeName) {
      const routeData = this.$router.resolve({ name: routeName })
      window.open(routeData.href, '_blank')
    },
    navigateToTerms() {
      this.openInNewTab('terms')
    },
    navigateToPrivacy() {
      this.openInNewTab('privacy')
    }
  }
}
</script>

<style lang="scss" scoped>
.guide_ment {
  margin-bottom: 24px;
  line-height: 20px;
  letter-spacing: 0;
  font-size: 16px;
  color: #777777;
}
.member_type {
  margin-bottom: 24px;
  li {
    &.student_wrap {
      margin-bottom: 16px;
    }
    input {
      display: none;
      &:checked + label {
        border: 1px solid #008df3;
        &::before {
          background: url('../../../assets/images/login_join/circle_checked.png')
            no-repeat;
          background-size: cover;
        }
      }
    }
    label {
      display: flex;
      align-items: center;
      gap: 15px;
      width: 100%;
      height: 81px;
      padding-left: 16px;
      border: 1px solid #d9d9d9;
      border-radius: 8px;
      font-weight: 600;
      font-size: 16px;
      color: #000;
      cursor: pointer;
      &::before {
        content: '';
        display: block;
        width: 22px;
        height: 22px;
        background: url('../../../assets/images/login_join/circle_check.png')
          no-repeat;
        background-size: cover;
      }
    }
  }
}
.text_label {
  padding-left: 16px;
  &.pdl {
    padding-left: 20px;
  }
  label {
    display: flex;
    align-items: center;
    height: 50px;
    border-radius: 8px;
    cursor: pointer;
    &.email_box {
      margin-top: 7px;
    }
    &.smsmms_box {
      margin-top: 5px;
    }
    &.email_box,
    &.smsmms_box {
      height: 33px;
    }
    em,
    span {
      line-height: 50px;
      letter-spacing: 0;
    }
  }
}
.check_all {
  margin-bottom: 8px;
  background-color: #f6f6f6;
  border-radius: 8px;
}
.next_btn {
  font-size: 18px;
  line-height: 56px;
  color: #fff;
}
.border_division {
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 4px;
  box-sizing: content-box;
}
.word_space {
  letter-spacing: -0.2px;
}
.bottom_font {
  font-family: 'pretendard-medium';
  font-size: 16px;
  color: #777777;
}
.benefit_info {
  margin: 17px 0 137px;
  padding-left: 16px;
  line-height: 20px;
  letter-spacing: 0;
  font-size: 16px;
  color: #777777;
}
</style>
